import {Intercom} from '@intercom/messenger-js-sdk';
import {useEffect} from 'react';

import {useFeatureFlag, useUserInfo} from 'core/hooks/authHooks';
import {useAuthStore, getFullName} from 'core/stores/auth';
import {FeatureFlags} from 'core/constants/featureFlags';

const APP_ID = 'ri7p35dw';

export const useInitializeIntercom = () => {
  const withIntercom = useFeatureFlag(FeatureFlags.Intercom);
  const name = useAuthStore(getFullName);
  const {id: user_id, profile: {email} = {}} = useUserInfo();

  useEffect(() => {
    if (!withIntercom) {
      return;
    }

    Intercom({
      app_id: APP_ID,
      user_id,
      name,
      email,
      vertical_padding: 120,
    });
  }, [email, name, user_id, withIntercom]);
};
